var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveDealerRealTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_51644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.824 82.3434V82.3251C170.813 82.3251 171.903 82.5903 172.755 82.252C173.644 81.8954 174.798 81.0633 174.963 80.2587C175.238 78.9146 174.148 78.1282 172.737 78.1008C170.905 78.0734 169.073 78.1465 167.249 78.0734C165.93 78.0185 165.591 78.5946 165.518 79.8198C165.408 81.6394 165.848 82.6909 167.937 82.3617C168.55 82.2611 169.201 82.3434 169.833 82.3434H169.824ZM134.296 46.7566H134.277C134.277 47.7349 134.122 48.759 134.342 49.6825C134.47 50.2128 135.212 50.9626 135.679 50.9718C136.65 50.9809 138.272 51.7398 138.437 50.0391C138.647 47.8264 138.62 45.5496 138.308 43.346C138.217 42.6877 136.888 41.8007 136.101 41.7642C135.533 41.7367 134.616 42.8614 134.369 43.6295C134.067 44.5804 134.296 45.7051 134.296 46.7566Z",
    fill: "url(#paint0_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.753 115.279H94.8101C94.8101 112.783 94.7551 110.341 94.8284 107.9C94.8834 106.218 94.3062 105.422 92.5106 105.495C90.1103 105.596 87.7008 105.577 85.3006 105.495C83.7523 105.449 83.1018 106.08 83.1293 107.607C83.1751 110.076 83.1385 112.545 83.1385 115.178H75.223C75.223 112.737 75.168 110.286 75.2413 107.854C75.2963 106.144 74.655 105.404 72.8777 105.495C70.7064 105.596 68.5351 105.523 66.2356 105.523V85.489C66.3914 85.3884 66.4921 85.2513 66.6112 85.2421C70.459 84.8581 70.4865 84.8032 68.6817 81.2372C66.3547 76.638 64.0277 72.0479 61.719 67.4396C60.6105 65.2268 61.0686 64.5136 63.5697 64.5136C78.2829 64.5136 92.9961 64.5136 107.709 64.5136C110.513 64.5136 110.888 65.2817 109.972 67.8327C108.726 71.3256 107.764 74.9282 106.546 78.9239C104.97 78.9239 102.799 78.8233 100.655 78.9788C99.9405 79.0336 99.2626 79.7468 98.5755 80.1583C99.2442 80.5972 99.8764 81.347 100.573 81.4018C102.671 81.5664 104.796 81.4658 106.922 81.4658C109.221 97.842 118.483 107.178 135.102 109.573C135.102 111.64 135.001 113.807 135.166 115.955C135.221 116.641 135.991 117.272 136.43 117.921C136.843 117.29 137.557 116.669 137.603 116.01C137.75 113.843 137.658 111.667 137.658 109.976C141.762 108.695 145.509 107.534 149.266 106.355C150.851 105.861 151.721 106.519 151.739 108.394C151.785 111.85 151.748 115.315 151.748 118.772C151.748 125.264 151.767 131.765 151.748 138.257C151.73 144.959 147.442 149.229 140.718 149.238C128.973 149.256 117.237 149.238 105.492 149.238C104.924 149.238 104.283 149.101 103.816 149.311C103.33 149.54 102.68 150.125 102.698 150.537C102.716 150.957 103.404 151.625 103.871 151.698C105.053 151.871 106.271 151.78 107.471 151.771C108.827 151.771 109.569 152.228 108.919 153.691C106.738 158.574 110.339 164.042 116.193 163.758C122.972 163.438 129.77 163.639 136.559 163.731C137.686 163.749 139.17 164.005 139.839 164.737C140.608 165.587 141.167 167.242 140.865 168.266C140.553 169.299 139.151 170.113 138.08 170.771C137.557 171.091 136.696 170.881 135.991 170.881C104.228 170.881 72.4654 170.881 40.7027 170.881C40.1347 170.881 39.5667 170.899 39.0079 170.854C37.029 170.689 35.8655 169.537 35.664 167.635C35.4716 165.806 36.406 164.49 38.1833 163.959C38.9712 163.722 39.8507 163.694 40.6936 163.694C47.4822 163.676 54.28 163.694 61.0686 163.676C66.5563 163.667 69.7445 159.278 67.9671 154.048C67.3625 152.274 67.8297 151.67 69.5979 151.753C70.5873 151.798 71.6134 151.917 72.557 151.698C73.1433 151.561 73.6014 150.866 74.1145 150.427C73.6289 150.024 73.1983 149.43 72.6395 149.275C71.9157 149.074 71.1003 149.22 70.3216 149.22C59.0073 149.22 47.6837 149.22 36.3694 149.22C29.2418 149.22 25.0275 145.041 25.0184 137.9C25.0001 117.208 25.0001 96.5162 25.0184 75.8334C25.0184 68.5734 29.2052 64.4862 36.5251 64.477C38.6506 64.477 40.7669 64.4496 42.8923 64.477C45.0544 64.5136 45.5308 65.2817 44.5414 67.2658C42.1411 72.0571 39.7041 76.83 37.2855 81.6213C35.7739 84.6112 35.948 84.913 39.2186 85.1324C39.4293 85.1507 39.6309 85.2238 40.0889 85.3244C40.0889 86.1108 40.0889 86.9337 40.0889 87.7566C40.0889 103.858 40.0889 119.96 40.0889 136.053C40.0889 138.778 40.2447 138.952 42.9473 138.952C65.7959 138.952 88.6445 138.952 111.493 138.952C114.177 138.952 114.37 138.741 114.37 136.044C114.37 126.791 114.37 117.546 114.37 108.293C114.37 105.559 114.296 105.486 111.466 105.486C109.276 105.486 107.077 105.541 104.888 105.468C103.33 105.413 102.707 106.062 102.735 107.589C102.781 110.113 102.744 112.636 102.744 115.242L102.753 115.279Z",
    fill: "url(#paint1_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.667 106.738C137.667 104.645 137.786 102.743 137.612 100.868C137.548 100.146 136.824 99.4876 136.394 98.8018C135.972 99.4693 135.239 100.109 135.175 100.813C135.001 102.688 135.12 104.59 135.12 106.455C124.255 107.022 110.155 96.6348 109.926 81.4747C111.887 81.4747 113.866 81.5936 115.817 81.4107C116.504 81.3467 117.127 80.5695 117.778 80.1214C117.136 79.7283 116.513 79.0425 115.845 78.9876C113.893 78.8322 111.914 78.9328 109.771 78.9328C110.265 71.499 113.142 65.4368 118.474 60.5633C122.597 56.7961 127.461 54.5468 133.041 53.8519C134.525 53.669 135.157 54.1811 135.12 55.6623C135.084 57.1436 135.02 58.634 135.175 60.1061C135.23 60.6456 135.881 61.1211 136.256 61.624C136.724 61.1211 137.511 60.6639 137.585 60.097C137.786 58.7163 137.731 57.2807 137.649 55.8726C137.539 54.1536 138.208 53.7056 139.903 53.861C150.2 54.812 159.92 63.5898 162.302 74.2055C163.011 77.3509 161.777 78.9236 158.601 78.9236C157.896 78.9236 157.126 78.7499 156.503 78.9785C155.898 79.1979 155.459 79.838 154.936 80.286C155.44 80.6792 155.908 81.3467 156.448 81.4015C157.841 81.5661 159.279 81.5478 160.681 81.4381C162.586 81.2918 162.962 82.1696 162.751 83.8612C161.368 95.2815 151.382 105.23 139.93 106.501C139.298 106.574 138.666 106.62 137.658 106.72L137.667 106.738ZM151.052 80.1123C150.997 72.0202 144.373 65.446 136.311 65.4825C128.158 65.5191 121.552 72.2397 121.635 80.414C121.717 88.433 128.497 95.0529 136.513 94.9432C144.602 94.8335 151.116 88.1952 151.061 80.1123H151.052Z",
    fill: "url(#paint2_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2173 136.217V108.192H72.6669C72.6669 110.634 72.7585 113.02 72.6394 115.398C72.5387 117.363 73.3357 118.022 75.2504 117.93C77.7882 117.811 80.335 117.903 82.8819 117.903C85.5937 117.903 85.6761 117.811 85.6853 114.986C85.6853 112.746 85.6853 110.506 85.6853 108.192H92.2541C92.2541 110.762 92.309 113.212 92.2357 115.663C92.1808 117.281 92.7763 117.976 94.4528 117.93C97.3478 117.848 100.252 117.857 103.147 117.93C104.704 117.967 105.337 117.318 105.318 115.809C105.282 113.349 105.309 110.881 105.309 108.247H111.658V136.227H66.2264L66.2173 136.217Z",
    fill: "url(#paint3_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4322 85.3154V136.291H42.7549V85.3154H63.4322ZM58.3751 101.957C58.3751 100.686 58.4301 99.4149 58.3659 98.1439C58.2102 95.2271 56.0023 93.0509 53.1989 92.9869C50.3497 92.9138 47.9769 95.1356 47.7937 98.1347C47.7112 99.4697 47.757 100.814 47.7662 102.158C47.8028 108.037 47.0882 107.342 52.9699 107.333C59.1905 107.324 58.3201 108.138 58.3751 101.966V101.957Z",
    fill: "url(#paint4_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.898 29.0005C58.6408 29.0005 65.2095 28.9731 71.7691 29.0736C72.2913 29.0736 73.1983 30.0703 73.2349 30.6372C73.3907 33.4534 73.2899 36.2788 73.3082 39.095C73.3082 40.558 72.4195 40.814 71.2102 40.8049C66.4738 40.7866 61.7373 40.8049 57.01 40.8049C56.2405 40.8049 55.4801 40.8049 54.399 40.8049C54.399 43.676 54.6281 46.419 54.3532 49.1072C53.6936 55.6632 55.2785 61.5334 58.6408 67.1933C61.5083 72.0119 63.7712 77.1872 66.428 82.4448H39.8873C40.208 81.7133 40.4737 81.0458 40.7943 80.4058C44.1566 73.7401 47.5738 67.0927 50.8719 60.3904C51.4399 59.2384 51.788 57.8485 51.788 56.5684C51.8155 48.3209 51.7239 40.0642 51.6872 31.8167C51.6872 30.9206 51.8155 30.0246 51.898 29.0005Z",
    fill: "url(#paint5_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6233 36.7996C88.8918 37.9791 87.1511 39.1495 85.4287 40.3473C83.3216 41.8012 83.3308 42.3406 85.4929 43.8402C87.2061 45.0197 88.9284 46.1992 90.495 47.8268C89.9087 47.8725 89.3132 47.964 88.7269 47.9731C82.5062 47.9822 76.2765 47.9822 70.0559 47.9731C67.6189 47.9731 66.6295 46.6107 67.4357 44.2608C67.5731 43.8676 68.1778 43.5019 68.6359 43.3922C69.2313 43.2459 69.9001 43.3556 70.5323 43.3464C74.7007 43.3464 75.6902 42.3315 75.9192 38.1254C75.9558 37.458 76.5696 36.2693 76.9453 36.2602C81.4344 36.1321 85.9326 36.1779 90.4309 36.1779C90.5042 36.3882 90.5683 36.5893 90.6416 36.7996H90.6233Z",
    fill: "url(#paint6_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.824 82.3439C169.192 82.3439 168.541 82.2616 167.927 82.3622C165.839 82.6914 165.399 81.6398 165.509 79.8203C165.582 78.6042 165.921 78.019 167.24 78.0738C169.063 78.1561 170.905 78.0738 172.728 78.1013C174.139 78.1287 175.229 78.9151 174.954 80.2592C174.789 81.0638 173.635 81.8959 172.746 82.2525C171.894 82.5908 170.804 82.3256 169.815 82.3256V82.3439H169.824Z",
    fill: "url(#paint7_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.296 46.7566C134.296 45.7051 134.067 44.5804 134.369 43.6295C134.616 42.8614 135.523 41.7367 136.101 41.7642C136.898 41.8007 138.217 42.6877 138.308 43.346C138.611 45.5405 138.647 47.8264 138.437 50.0391C138.272 51.7398 136.65 50.9901 135.679 50.9718C135.203 50.9718 134.47 50.2128 134.342 49.6825C134.122 48.7499 134.277 47.7349 134.277 46.7566H134.296Z",
    fill: "url(#paint8_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8282 104.709H50.3589C50.3589 102.451 50.2581 100.22 50.3955 98.016C50.4963 96.4981 51.5682 95.5564 53.0707 95.5655C54.6647 95.5746 55.7275 96.5347 55.8008 98.1897C55.8924 100.284 55.8191 102.387 55.8191 104.709H55.8282Z",
    fill: "url(#paint9_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.452 78.4396C134.442 78.9425 134.021 79.3539 133.508 79.3448C132.995 79.3448 132.583 78.9333 132.583 78.4121C132.583 77.891 133.013 77.4795 133.508 77.4795C134.003 77.4795 134.461 77.9275 134.452 78.4396Z",
    fill: "url(#paint10_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.077 78.4306C140.077 78.9426 139.655 79.3541 139.133 79.3449C138.62 79.3449 138.208 78.9335 138.208 78.4214C138.208 77.9094 138.629 77.4888 139.133 77.4796C139.637 77.4705 140.086 77.9185 140.077 78.4306Z",
    fill: "url(#paint11_linear_116_51644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.476 68.0343C129.862 67.9429 124.255 73.4108 124.172 80.0399C124.099 86.7787 129.614 92.3837 136.33 92.402C143.008 92.402 148.45 86.989 148.487 80.2867C148.524 73.5754 143.182 68.1349 136.476 68.0343ZM142.156 85.9009C141.469 85.8735 140.837 85.4986 140.452 84.7488C140.049 83.9808 139.664 83.1944 139.28 82.4081C139.188 82.2343 139.096 82.152 138.877 82.152C137.182 82.1612 135.487 82.1612 133.792 82.152C133.6 82.152 133.49 82.2069 133.407 82.3806C133.032 83.1578 132.638 83.9259 132.253 84.694C131.74 85.6906 130.741 86.1295 129.724 85.8003C128.717 85.4803 128.139 84.5019 128.323 83.423C128.652 81.384 128.991 79.345 129.34 77.3059C129.587 75.7972 130.833 74.6909 132.372 74.6817C135.01 74.6543 137.649 74.6634 140.278 74.6726C141.643 74.6817 143.1 75.6144 143.393 77.5711C143.686 79.537 144.034 81.5028 144.355 83.4687C144.566 84.758 143.613 85.8918 142.156 85.9009Z",
    fill: "url(#paint12_linear_116_51644)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_51644",
    x1: 154.609,
    y1: 41.7637,
    x2: 154.609,
    y2: 82.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_51644",
    x1: 88.3834,
    y1: 64.4648,
    x2: 88.3834,
    y2: 170.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_51644",
    x1: 136.287,
    y1: 53.8164,
    x2: 136.287,
    y2: 106.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_116_51644",
    x1: 88.9376,
    y1: 108.192,
    x2: 88.9376,
    y2: 136.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_116_51644",
    x1: 53.0936,
    y1: 85.3154,
    x2: 53.0936,
    y2: 136.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_116_51644",
    x1: 56.6054,
    y1: 28.9971,
    x2: 56.6054,
    y2: 82.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_116_51644",
    x1: 78.9009,
    y1: 36.1699,
    x2: 78.9009,
    y2: 47.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_116_51644",
    x1: 170.245,
    y1: 78.0703,
    x2: 170.245,
    y2: 82.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_116_51644",
    x1: 136.391,
    y1: 41.7637,
    x2: 136.391,
    y2: 51.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_116_51644",
    x1: 53.085,
    y1: 95.5654,
    x2: 53.085,
    y2: 104.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_116_51644",
    x1: 133.517,
    y1: 77.4795,
    x2: 133.517,
    y2: 79.3449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_116_51644",
    x1: 139.142,
    y1: 77.4795,
    x2: 139.142,
    y2: 79.3451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_116_51644",
    x1: 136.329,
    y1: 68.0332,
    x2: 136.329,
    y2: 92.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_51644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 142,
    fill: "white",
    transform: "translate(25 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDealerRealTime);
export default __webpack_public_path__ + "static/media/Live_Dealer_&_Real-Time.1d73befffd20cf909ba0af7c1b1bf39f.svg";
export { ForwardRef as ReactComponent };